import { useState } from 'react';
import { Box } from '@mui/material';
import { submitToVizzleLibraryTooltipText } from '../../../../texts/TooltipText';
import ButtonWithSpinner from '../../../../components/buttons/ButtonWithSpinner';
import TooltipWithIndicator from '../../../../components/tooltip/TooltipWithIndicator';
import { useDomain } from '../../../../states/AppDomainProvider';
import { submitLessonToVizzleLibrary } from '../../../../services/LessonService';
import { UNAUTHORIZED } from '../../../../AppConstants';
import Logger from '../../../../utils/Logger';

/**
 * Lesson stepper submit a lesson to vizzle library
 * @export
 */
export default function LessonStepperSubmitVizzleLibrary({ disabled } = {
  disabled: false,
}) {
  const { lessonDataMaintenanceDomain, uiDomain } = useDomain();
  const { lessonData } = lessonDataMaintenanceDomain.domainData;
  const [loading, setLoading] = useState(false);

  const onClickHandler = async () => {
    try {
      setLoading(true);
      await submitLessonToVizzleLibrary(lessonData.attributes.uuid);
      const updatedLessonData = {
        ...lessonData,
        attributes: {
          ...lessonData.attributes,
          submitted: true,
        },
      };
      await lessonDataMaintenanceDomain.updateLessonData(updatedLessonData, false);
      await uiDomain.showSnackbar(true, 'info', 3000, 'The activity has been submitted to the library.');
      setLoading(false);
    } catch (error) {
      if (error.response && UNAUTHORIZED !== error.response.status) {
        await uiDomain.showSnackbar(true, 'error', 300000, error.response.data);
      }
      Logger.logError({
        ERROR: error,
      });
      setLoading(false);
    }
  };

  return (
    <Box display='flex'>
      <ButtonWithSpinner
        disabled={!lessonData.attributes || lessonData.attributes.submitted || disabled}
        label='Share with the World!'
        onClick={onClickHandler}
        loading={loading}
        fullWidth
        className='vizzle-submit-lesson-to-vizzle-lib'
        data-test='share-with-the-world-action'
      />
      <Box display='flex' ml='10px' my='auto'>
        <TooltipWithIndicator className='vizzle-submit-lesson-tooltip' {...submitToVizzleLibraryTooltipText} />
      </Box>
    </Box>
  );
}
